import { useCallback, useContext, useRef, useState } from 'react';
import { SharedIntersectionObserverContext } from './context';

export const useSharedIntersectionObserver: () => [(node) => void, boolean] = () => {
    const { addElement, removeElement, defaultVisible } = useContext(SharedIntersectionObserverContext);
    const [isVisible, setIsVisible] = useState(defaultVisible);

    const elementRef = useRef(null);
    const refCallback = useCallback(
        node => {
            if (elementRef.current) {
                removeElement(elementRef.current);
            }

            if (node) {
                addElement(node, visible => setIsVisible(visible));
            }

            elementRef.current = node;
        },
        [addElement, removeElement]
    );

    return [refCallback, isVisible];
};
